import { createSelector } from 'reselect';

export const stairs = createSelector(
  (state) => state.steps,
  (steps) => steps,
);

export const hasSavedStepsSelector = createSelector(
  (state) => state.steps,
  (steps) => steps?.stairsSquareFeet > 0
);
